import {GET_COORDS} from './actionTypes'

const initialState = {
  coords: {},
  // isLoading: false,
  // hasError: false,
  fulfilledCoords: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_COORDS:
      return {
        ...state,
        coords: action.payload,
        fulfilledCoords: true,
      }

    default:
      return state
  }
}
